/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  avatar1,
  avatar13,
  avatar16,
  avatar18,
  avatar19,
  avatar2,
  avatar20,
  avatar21,
  avatar23,
  avatar26,
  avatar4,
  avatar6,
  avatar8,
  clockin,
  employeeimg,
  holidaycalendar,
} from "../../../../../Routes/ImagePath";
import "./style/dashboardStyle.css";
import {
  getAnniversary,
  getBirthday,
  getNewJoiners,
  getPublicHoliday,
  getTerminated,
  getEmployeeLeaveStatus,
  documentExpiry
} from "api/services/dashboard";
import { SkeltonLoader } from "components/skeltonLoader";
import Image from "components/Image";
import { format } from "date-fns";
import dashBoardImage from "../../../../../assets/img/dashboard.png";
import Cover1 from "../../../../../assets/img/cover.jpeg";
import Cover2 from "../../../../../assets/img/cover2.jpeg";
import Cover3 from "../../../../../assets/img/cover3.jpeg";
import Cover4 from "../../../../../assets/img/cover4.jpeg";

import { dateLeftHandler, formatBirthdayHandler, formatDateHandler } from "utils/common";
import Carousel from 'react-bootstrap/Carousel';
import { Popover } from 'antd';
// import ExampleCarouselImage from 'components/ExampleCarouselImage';

const DocumentExpiryCard = ({ title, data, filter, setFilter, loading, type, icon }) => {
  const [isChangingFilter, setIsChangingFilter] = useState(false);

  const handleFilterChange = (newFilter) => {
    setIsChangingFilter(true);
    setFilter(newFilter);
    
    // Simulate loading effect for better UX
    setTimeout(() => {
      setIsChangingFilter(false);
    }, 800);
  };

  return (
    <div className="card flex-fill">
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          <h4 className="mb-0">
            <div className="d-flex align-items-center">
              {title}
              <span className="ms-2" style={{ fontSize: "18px" }}>
                {icon || "📄"}
              </span>
            </div>
          </h4>
        </div>
        
        {loading ? (
          <SkeltonLoader number={1} active={true} className="col-12" height={40} />
        ) : (
          <div className="row">
            <div className="col-12">
              <div className="expiry-items">
                <div className="expiry-item d-flex justify-content-between align-items-center p-2 mb-2" 
                    onClick={() => handleFilterChange("today")}
                    style={{cursor: 'pointer', backgroundColor: filter === "today" ? "#f8f9fa" : "", borderRadius: "4px"}}>
                  <span>Expiring Today</span>
                  {isChangingFilter && filter === "today" ? (
                    <div className="shimmer shimmer-badge" style={{width: "30px", height: "20px", borderRadius: "10px"}}></div>
                  ) : (
                    <span className={`badge ${data.expiry_today > 0 ? 'bg-danger' : 'text-dark'} rounded-pill`}>
                      {data.expiry_today || 0}
                    </span>
                  )}
                </div>
                <div className="expiry-item d-flex justify-content-between align-items-center p-2 mb-2"
                    onClick={() => handleFilterChange("in30days")}
                    style={{cursor: 'pointer', backgroundColor: filter === "in30days" ? "#f8f9fa" : "", borderRadius: "4px"}}>
                  <span>Expiring in 30 Days</span>
                  {isChangingFilter && filter === "in30days" ? (
                    <div className="shimmer shimmer-badge" style={{width: "30px", height: "20px", borderRadius: "10px"}}></div>
                  ) : (
                    <span className={`badge ${data.expiry_in_30_days > 0 ? 'bg-danger' : 'text-dark'} rounded-pill`}>
                      {data.expiry_in_30_days || 0}
                    </span>
                  )}
                </div>
                <div className="expiry-item d-flex justify-content-between align-items-center p-2 mb-2"
                    onClick={() => handleFilterChange("in60days")}
                    style={{cursor: 'pointer', backgroundColor: filter === "in60days" ? "#f8f9fa" : "", borderRadius: "4px"}}>
                  <span>Expiring in 60 Days</span>
                  {isChangingFilter && filter === "in60days" ? (
                    <div className="shimmer shimmer-badge" style={{width: "30px", height: "20px", borderRadius: "10px"}}></div>
                  ) : (
                    <span className={`badge ${data.expiry_in_60_days > 0 ? 'bg-danger' : 'text-dark'} rounded-pill`}>
                      {data.expiry_in_60_days || 0}
                    </span>
                  )}
                </div>
                <div className="expiry-item d-flex justify-content-between align-items-center p-2"
                    onClick={() => handleFilterChange("in90days")}
                    style={{cursor: 'pointer', backgroundColor: filter === "in90days" ? "#f8f9fa" : "", borderRadius: "4px"}}>
                  <span>Expiring in 90 Days</span>
                  {isChangingFilter && filter === "in90days" ? (
                    <div className="shimmer shimmer-badge" style={{width: "30px", height: "20px", borderRadius: "10px"}}></div>
                  ) : (
                    <span className={`badge ${data.expiry_in_90_days > 0 ? 'bg-danger' : 'text-dark'} rounded-pill`}>
                      {data.expiry_in_90_days || 0}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const EmployeeDashboard = () => {

  // const [menu, setMenu] = useState(false);

  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };
  const [chartOptions] = useState({
    series: [
      {
        name: "Sales",
        data: [-50, -120, -80, -180, -80, -70, -100],
      },
      {
        name: "Purchase",
        data: [200, 250, 200, 290, 220, 300, 250],
      },
    ],
    colors: ["#FC133D", "#55CE63"],
    chart: {
      type: "bar",
      height: 210,
      stacked: true,

      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 280,
        options: {
          legend: {
            position: "bottom",
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        borderRadiusApplication: "end", // "around" / "end"
        borderRadiusWhenStacked: "all", // "all"/"last"
        columnWidth: "30%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      min: -200,
      max: 300,
      tickAmount: 5,
    },
    xaxis: {
      categories: ["S", "M", "T", "W", "T", "F", "S"],
    },
    legend: { show: false },
    fill: {
      opacity: 1,
    },
  });

  const { user, userLoading } = useSelector((state) => state.user);

  const [publicHoliday, setPublicHoliday] = useState([]);
  const [birthdays, setBirthDays] = useState([]);
  const [birthdayLoading, setBirthdayLoading] = useState(true);

  const [anniversary, setAnniversary] = useState([]);
  const [anniversaryLoading, setAnniversaryLoading] = useState(true);

  const [newJoiners, setnewJoiners] = useState([]);
  const [newJoinersLoading, setNewJoinersLoading] = useState(true);

  const [terminated, setTerminated] = useState([]);
  const [terminatedLoading, setTerminatedLoading] = useState(true);

  const [greeting, setGreeting] = useState("");

  const [anniversaryFilter, setAnniversaryFilter] = useState("month");
  const [birthdayFilter, setBirthdayFilter] = useState("month");
  const [leaveFilter, setLeaveFilter] = useState("month");

  const [leaves, setLeaves] = useState([]);
  const [leavesLoading, setLeavesLoading] = useState(true);

  const [userDocumentExpiry, setUserDocumentExpiry] = useState({
    expiry_today: 0,
    expiry_in_30_days: 0,
    expiry_in_60_days: 0, 
    expiry_in_90_days: 0
  });

  const [storeDocumentExpiry, setStoreDocumentExpiry] = useState({
    expiry_today: 0,
    expiry_in_30_days: 0,
    expiry_in_60_days: 0,
    expiry_in_90_days: 0
  });

  const [userExpiryFilter, setUserExpiryFilter] = useState("today");
  const [storeExpiryFilter, setStoreExpiryFilter] = useState("today");
  const [documentExpiryLoading, setDocumentExpiryLoading] = useState(true);

  const [openPopoverIds, setOpenPopoverIds] = useState([]);

  const fetchAnniversaryData = (value) => {
    setAnniversaryLoading(true); // Show loader before API call
    getAnniversary(null, { day_filter: value })
      .then((response) => {
        setAnniversary(response.data);
        setAnniversaryLoading(false);
      })
      .catch(() => {
        setAnniversaryLoading(false);
      });
  };

  const fetchBirthdayData = (value) => {
    setBirthdayLoading(true); // Show loader before API call
    getBirthday(null, { day_filter: value })
      .then((response) => {
        setBirthDays(response.data);
        setBirthdayLoading(false);
      })
      .catch(() => {
        setBirthdayLoading(false);
      });
  };

  const fetchData = () => {
    getPublicHoliday().then((response) => {
      setPublicHoliday(response.data.results);
    });

    fetchAnniversaryData(anniversaryFilter);
    fetchBirthdayData(birthdayFilter);

    getNewJoiners()
      .then((response) => {
        setnewJoiners(response.data);
        setNewJoinersLoading(false);
      })
      .catch(() => {
        setNewJoinersLoading(false);
      });

    getTerminated()
      .then((response) => {
        setTerminated(response.data);
        setTerminatedLoading(false);
      })
      .catch(() => {
        setTerminatedLoading(false);
      });
  };

  const getLeaveData = (param) => {
    setLeavesLoading(true);
    getEmployeeLeaveStatus(param)
      .then((response) => {
        setLeaves(response.data);
        setLeavesLoading(false);
      })
      .catch(() => {
        setLeavesLoading(false);
      });
  };
  useEffect(() => {
    getLeaveData({ day_filter: leaveFilter });
  }, [leaveFilter]);

  const fetchDocumentExpiryData = () => {
    setDocumentExpiryLoading(true);
    documentExpiry()
      .then(response => {
        setUserDocumentExpiry(response.data.user_document || {
          expiry_today: 0,
          expiry_in_30_days: 0,
          expiry_in_60_days: 0,
          expiry_in_90_days: 0
        });
        
        setStoreDocumentExpiry(response.data.store_document || {
          expiry_today: 0,
          expiry_in_30_days: 0,
          expiry_in_60_days: 0,
          expiry_in_90_days: 0
        });
        
        setDocumentExpiryLoading(false);
      })
      .catch(error => {
        console.error("Error fetching document expiry data:", error);
        setDocumentExpiryLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    fetchDocumentExpiryData();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    marginrigth: 10,
  };
  const settingsprojectslide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  const UserCard = () => {
    if (userLoading) {
      return (
        <div className="card   flex-fill">
          <SkeltonLoader
            number={1}
            active={true}
            className="col-lg-6 col-md-12 card w-100"
          />
        </div>
      );
    }
    return (
      <div className="card employee-welcome-card flex-fill h-100">
        <div className="card-body">
          <div className="welcome-info">
            <div className="welcome-content">
              {console.log(user, "lll")}
              <h4>Welcome Back, {user?.first_name}</h4>
              {/* <p>
                            You have <span>4 meetings</span> today,
                          </p> */}
            </div>
            <div className="welcome-img">
              <Image src={user?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }}  />
            </div>
          </div>
          {
              user?.role?.access_scope !== "store_manager" && 
              <div className="welcome-btn">
            <Link to={`/company-directory/${user?.id}`} className="btn">
              View Profile
            </Link>
          </div>
            }
          
        </div>
      </div>
    );
  };

  useEffect(() => {
    const getGreeting = () => {
      const currentHour = new Date().getHours(); // Get the current hour (0-23)
      if (currentHour < 12) {
        return "Good Morning";
      } else if (currentHour < 18) {
        return "Good Afternoon";
      } else {
        return "Good Evening";
      }
    };

    setGreeting(getGreeting());
  }, []); // Empty dependency array ensures it runs only once when the component mounts

  const displayTitleSubText = (type, count) => {
    var subText = "";
    var employeeText = count === 1 ? "employee" : "employees"
    var hasText = count === 1 ? "has" : "have";
    var isText  = count === 1 ? "is" : "are";
    // var wasText  = count === 1 ? "was" : "were";
 
    if (type === "anniversary") {
      subText = " "+ employeeText + " " + isText + " celebrating work anniversary";
    } else if (type === "birthday") {
      subText = " "+ employeeText + " " + isText + " celebrating birthday";
    } else if (type === "terminated") {
      subText = " "+ employeeText + " resigned in last 30 days";
    } else if(type === "new_joiners") {
      subText = " "+ employeeText + " " + hasText + " joined in last 30 days";
    }
    return subText;
  }
 

  const SliderComponent = ({ title, loading, list, type, count }) => {
    const [isFetching, setIsFetching] = useState(false); // Control shimmer visibility

    const handleFilterChange = async (e) => {
      const newValue = e.target.value;
      setIsFetching(true); // Show shimmer effect immediately
  
      if (type === "anniversary") {
        setAnniversaryFilter(newValue);
        await fetchAnniversaryData(newValue);
      } else if (type === "birthday") {
        setBirthdayFilter(newValue);
        await fetchBirthdayData(newValue);
      }
  
      // Delay hiding shimmer to make it more evident
      setTimeout(() => {
        setIsFetching(false);
      }, 1200);
    };
  
    return (
      <div className="card flex-fill">
        <div className="card-body d-flex flex-column">
          {/* Header Section */}
          <div className="row align-items-center mb-3" style={{ minHeight: "50px" }}>
            <div className="col-sm-12 d-flex align-items-center justify-content-between">
              <h4 className="me-9 mb-0">
                <div className="d-flex align-items-center">
                  {title}
                  {type === "anniversary" && <span className="ms-2" style={{ fontSize: "24px" }}>🎉</span>}
                  {type === "birthday" && <span className="ms-2" style={{ fontSize: "18px" }}>🎂</span>}
                  {(type === "new_joiners" || type === "terminated") && (
                    <span className="ms-2 d-inline-flex align-items-center" style={{ fontSize: "16px" }}>🧑‍💼</span>
                  )}
                </div>

                <span style={{ fontSize: "12px" }} className="small text-muted d-block mt-1">
                  {isFetching || loading ? (
                    <div className="shimmer shimmer-text" style={{width: "120px", height: "14px"}}></div> // Shimmer effect
                  ) : (
                    `${count} ${displayTitleSubText(type, count)}`
                  )}
                </span>
              </h4>
  
              {/* Dropdown */}
              <div style={{ visibility: type === "anniversary" || type === "birthday" ? "visible" : "hidden" }}>
                <select
                  className="form-select form-select-sm"
                  value={type === "anniversary" ? anniversaryFilter : birthdayFilter}
                  onChange={handleFilterChange}
                >
                  
                      <option value="today">Today</option>
                    
                  <option value="week">This Week</option>

                  <option value="month">This Month</option>
                </select>
              </div>
            </div>
          </div>
  
          {(loading || isFetching) && (
            <div className="row p-0 m-0">
              <SkeltonLoader number={3} active={true} className="col-4 card" />
            </div>
          )}
  
          {!loading && !isFetching && (
            <div className="scroll-container d-flex" style={{ marginTop: "9px" }}>
              {list.map((item, index) => (
                <div key={index} className="profile-card" style={{ marginRight: "20px" }}>
                  <div
                    className={`company-grid ${
                      type === "anniversary" ? "company-soft-tertiary" : "company-soft-success"
                    } d-flex flex-column h-100`}
                  >
                    <div className="company-top">
                      <div className="company-icon">
                        <span className="company-icon-tertiary rounded-circle profile-img avatar">
                          <Image src={item?.profile_image} type="user" style={{ objectFit: "cover" }} />
                        </span>
                      </div>
                      <div className="company-link overflow-scroll">
                        <Link to={`/company-directory/${item.id}`}>
                          {item?.first_name} {item?.last_name}
                        </Link>
                        <span className="d-block small text-muted">{item?.emp_no}</span>
                      </div>
                    </div>
  
                    <div className="company-bottom d-flex flex-grow-1">
                      <ul className="mb-0">
                        {type === "birthday" && <li>Birthday: {formatBirthdayHandler(item.birthday)}</li>}
                        {type !== "birthday" && type !== "terminated" && (
                          <li>Joined on: {formatDateHandler(item.employment_date)}</li>
                        )}
                        {type === "terminated" && item?.termination_date && (
                          <li>Resigned on: {formatDateHandler(item.termination_date)}</li>
                        )}
                        {type === "anniversary" && <li>{item.job_anniversary_count}</li>}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };
  

  

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid pb-0">
          {/* Leave Alert */}
          {/* <div className="row">
            <div className="col-md-12">
              <div className="employee-alert-box">
                <div className="alert alert-outline-success alert-dismissible fade show">
                  <div className="employee-alert-request">
                    <i className="far fa-circle-question" />
                    Your Leave Request on <span>"24th April 2024"</span> has been
                    Approved!!!
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                  >
                    <i className="fas fa-xmark" />
                  </button>
                </div>
              </div>
            </div>
          </div> */}
          {/* /Leave Alert */}
          <div className="row mb-4">
            <div className="col-lg-6">
              <div className="d-flex justify-content-center flex-column h-100">
                <h3>{greeting}, {user?.first_name}!</h3>
                <p>Here's what going with your ESS portal</p>
              </div>
            </div>
            {/* <div className="col-lg-8">
              <img
                src={dashBoardImage}
                style={{
                  width: "100%",
                  opacity: "0.5",
                  marginTop: -120,
                  marginBottom: -40,
                  height: 300,
                }}
              />
            </div> */}
          </div>











              <div className="col-6">
        

              </div>

        



          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="row">
                {/* Employee Details */}

                <div className="col-lg-8 col-md-12">
                  <div className="d-flex align-items-end row card justify-content-center px-2 py-4 main-card-bg-grey">
                    {/* <div className="col-12" >
                    <img src={dashBoardImage} style={{width:"100%", opacity:"0.5",marginTop:-120,marginBottom:-40,height:300}} />

                    </div> */}
                    <div className="row p-0 m-0">
                      {/* <div className="col-lg-6 col-md-12 mb-3">
                        <UserCard />
                      </div> */}
                      <div className="col-lg-6 col-md-12  mb-3">
                      <Carousel>
                      <Carousel.Item>
                        {/* <dashBoardImage text="First slide" /> */}
                        <img style={{borderRadius:"5px"}} src={Cover1} alt="First slide" />
                        <Carousel.Caption>
                          {/* <h3>Text Here</h3> */}
                          {/* <p>Text Here</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        {/* <ExampleCarouselImage text="Second slide" /> */}
                        <img style={{borderRadius:"5px"}} src={Cover2} alt="First slide" />
                        <Carousel.Caption>
                            {/* <p>Text Here</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        {/* <ExampleCarouselImage text="Third slide" /> */}
                        <img style={{borderRadius:"5px"}} src={Cover3} alt="First slide" />
                        <Carousel.Caption>
                        {/* <p>Text Here</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        {/* <ExampleCarouselImage text="Third slide" /> */}
                        <img style={{borderRadius:"5px"}} src={Cover4} alt="First slide" />
                        <Carousel.Caption>
                        {/* <p>Text Here</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                      </div>
                      <div className="col-lg-6 col-md-12  mb-3">
                        <div className="card info-card flex-fill h-100">
                          <div className="card-body">
                            <h4>Upcoming Holidays</h4>
                            <div className="holiday-details">
                              <div className="holiday-calendar">
                                <div className="holiday-calendar-icon">
                                  <img src={holidaycalendar} alt="Icon" />
                                </div>
                                <div className="holiday-calendar-content">
                                  <h6>{publicHoliday[0]?.name}</h6>
                                  <p>{publicHoliday[0]?.date}</p>
                                </div>
                              </div>
                              <div className="holiday-btn">
                                <Link to="/holidays" className="btn">
                                  View All
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="card flex-fill">
                    <div className="card-body">
                      <div className="statistic-header">
                        <h4>Statistics</h4>
                        <div className="dropdown statistic-dropdown">
                          <Link
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                            to="#"
                          >
                            Today
                          </Link>
                          <div className="dropdown-menu dropdown-menu-end">
                            <Link to="#" className="dropdown-item">
                              Week
                            </Link>
                            <Link to="#" className="dropdown-item">
                              Month
                            </Link>
                            <Link to="#" className="dropdown-item">
                              Year
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="clock-in-info">
                        <div className="clock-in-content">
                          <p>Work Time</p>
                          <h4>6 Hrs : 54 Min</h4>
                        </div>
                        <div className="clock-in-btn">
                          <Link to="#" className="btn btn-primary">
                            <img src={clockin} alt="Icon" />{" "}
                            Clock-In
                          </Link>
                        </div>
                      </div>
                      <div className="clock-in-list">
                        <ul className="nav">
                          <li>
                            <p>Remaining</p>
                            <h6>2 Hrs 36 Min</h6>
                          </li>
                          <li>
                            <p>Overtime</p>
                            <h6>0 Hrs 00 Min</h6>
                          </li>
                          <li>
                            <p>Break</p>
                            <h6>1 Hrs 20 Min</h6>
                          </li>
                        </ul>
                      </div>
                      <div className="view-attendance">
                        <Link to="/adminattendance">
                          View Attendance <i className="fe fe-arrow-right-circle" />
                        </Link>
                      </div>
                    </div>
                  </div> */}
                </div>
                {/* /Employee Details */}
                {/* Attendance & Leaves */}
                <div className="col-lg-4 col-md-12">
                  <div
                    className="p-4 card"
                    style={{ backgroundColor: "#d3d3d3a1" }}
                  >
                    <div className="card flex-fill m-0">
                      <div className="card-body">
                        <div className="statistic-header">
                          <h4>Leaves</h4>
                          <select
                            className="form-select form-select-sm w-50"
                            value={leaveFilter}
                            onChange={(e) => setLeaveFilter(e.target.value)}
                          >
                            <option value="today">Today</option>
                            <option value="week">This Week</option>
                            <option value="month">This Month</option>
                          </select>
                        </div>
                        <div className="attendance-list">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="attendance-details d-flex justify-content-between align-items-center">
                                <h4 style={{ fontSize: "12px" }} className="small text-muted d-block mt-1">
                                  {leaves?.total_leaves} Total Leaves
                                </h4>
                              </div>
                            </div>
                          </div>
                          <div className="overflow-scroll" style={{ maxHeight: 200 }}>
                            {leavesLoading ? (
                              <SkeltonLoader number={1} active={true} className="col-12" height={20} />
                            ) : (
                              leaves?.employees?.map((emp) => (
                                <Popover
                                  key={emp.id}
                                  content={
                                    <div>
                                      <p>Start Date: {formatDateHandler(emp.start_date)}</p>
                                      <p>End Date: {formatDateHandler(emp.end_date)}</p>
                                      <p>No. of Days: {emp.no_of_days || 1}</p>
                                      {/* <p>Cost Center: {emp.cost_center?.name}</p> */}
                                    </div>
                                  }
                                  trigger="hover"
                                  placement="top"
                                  open={openPopoverIds.includes(emp.id)}
                                  onOpenChange={(open) => {
                                    if (open) {
                                      setOpenPopoverIds([emp.id]);
                                    } else {
                                      setOpenPopoverIds(openPopoverIds.filter(id => id !== emp.id));
                                    }
                                  }}
                                >
                                  <div className="card-body d-flex justify-content-between p-2" style={{ cursor: 'pointer' }}>
                                    <div className="col-8 overflow-auto">
                                      <span className="d-inline-block text-nowrap m-0 small">
                                        {`${emp?.company_user?.first_name} ${emp?.company_user?.last_name}`} 
                                        <span className="d-block small text-muted">{emp?.company_user?.emp_no}, 
                                           &nbsp; {emp?.cost_center?.name}
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-4  d-flex justify-content-end align-items-center">
                                      <span className="badge overflow-auto badge-warning small badge-sm">
                                        {emp?.position?.name}
                                      </span>
                                    </div>
                                  </div>
                                </Popover>
                              ))
                            )}
                          </div>
                        </div>
                        <div className="view-attendance">
                          <Link to="/leaves-employee">
                            Apply Leave
                            <i className="fe fe-arrow-right-circle" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="card flex-fill">
                    <div className="card-body">
                      <div className="statistic-header">
                        <h4>Working hours</h4>
                        <div className="dropdown statistic-dropdown">
                          <Link
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                            to="#"
                          >
                            This Week
                          </Link>
                          <div className="dropdown-menu dropdown-menu-end">
                            <Link to="#" className="dropdown-item">
                              Last Week
                            </Link>
                            <Link to="#" className="dropdown-item">
                              This Month
                            </Link>
                            <Link to="#" className="dropdown-item">
                              Last 30 Days
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="working-hour-info">
                        <div id="working_chart" />
                        <Chart
                          options={chartOptions}
                          series={chartOptions.series}
                          type="bar"
                          height={210}
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
                {/* /Attendance & Leaves */}
              </div>
            </div>
            {/* Employee Notifications */}
            <div className="col-xxl-4 col-lg-12 col-md-12 d-flex">
              {/* <div className="card flex-fill">
                    <div className="card-body">
                      <div className="statistic-header">
                        <h4>Employee Stats</h4>
                     
                      </div>
                      <div className="attendance-list">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="attendance-details">
                              <h4 className="text-primary">9</h4>
                              <p>Total Employees</p>
                            </div>
                          </div>
                          <div className="row overflow-scroll" >
                          <div className="col-md-4">
                            <div className="attendance-details">
                              <h4 className="text-pink">5.5</h4>
                              <p>Leaves Taken</p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="attendance-details">
                              <h4 className="text-success">04</h4>
                              <p>Leaves Absent</p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="attendance-details">
                              <h4 className="text-purple">0</h4>
                              <p>Pending Approval</p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="attendance-details">
                              <h4 className="text-info">214</h4>
                              <p>Working Days</p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="attendance-details">
                              <h4 className="text-danger">2</h4>
                              <p>Loss of Pay</p>
                            </div>
                          </div>

                          </div>
                          
                          
                        </div>
                      </div>
                    
                    </div>
                  </div> */}
              {/* <div className="card flex-fill">
                <div className="card-body">
                  <div className="statistic-header">
                    <h4>Important</h4>
                    <div className="important-notification">
                      <Link to="/activities">
                        <span className="me-1">View All</span>
                        <ArrowRightCircle size={15} />
                      </Link>
                    </div>
                  </div>
                  <div className="notification-tab">
                    <ul className="nav nav-tabs">
                      <li>
                        <Link
                          to="#"
                          className="active"
                          data-bs-toggle="tab"
                          data-bs-target="#notification_tab"
                        >
                          <i className="la la-bell" /> Notifications
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#schedule_tab"
                        >
                          <i className="la la-list-alt" /> Schedules
                        </Link>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div className="tab-pane active" id="notification_tab">
                        <div className="employee-noti-content">
                          <ul className="employee-notification-list">
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-danger rounded-circle">
                                    HR
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Your leave request has been
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>02:10 PM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-info rounded-circle">
                                    ER
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    You're enrolled in upcom....
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>12:40 PM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-warning rounded-circle">
                                    SM
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Your annual compliance trai
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>11:00 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="rounded-circle">
                                    <img
                                      src={avatar1}
                                      className="img-fluid rounded-circle"
                                      alt="User"
                                    />
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Jessica has requested feedba
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>10:30 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-warning rounded-circle">
                                    DT
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Gentle remainder about train
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>09:00 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-danger rounded-circle">
                                    AU
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Our HR system will be down
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>11:50 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="schedule_tab">
                        <div className="employee-noti-content">
                          <ul className="employee-notification-list">
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="rounded-circle">
                                    <img
                                      src={avatar2}
                                      className="img-fluid rounded-circle"
                                      alt="User"
                                    />
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    John has requested feedba
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>10:30 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-danger rounded-circle">
                                    HR
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Your leave request has been
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>02:10 PM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-info rounded-circle">
                                    ER
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    You're enrolled in upcom....
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>12:40 PM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-warning rounded-circle">
                                    SM
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Your annual compliance trai
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>11:00 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-warning rounded-circle">
                                    DT
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Gentle remainder about train
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>09:00 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                            <li className="employee-notification-grid">
                              <div className="employee-notification-icon">
                                <Link to="/activities">
                                  <span className="badge-soft-danger rounded-circle">
                                    AU
                                  </span>
                                </Link>
                              </div>
                              <div className="employee-notification-content">
                                <h6>
                                  <Link to="/activities">
                                    Our HR system will be down
                                  </Link>
                                </h6>
                                <ul className="nav">
                                  <li>11:50 AM</li>
                                  <li>21 Apr 2024</li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            {/* /Employee Notifications */}
          </div>
          {/* <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>On Going Projects</h4>
                      </div>
                  </div>
                    <div className="col-sm-4 text-sm-end">
                      <div className="owl-nav project-nav nav-control" />
                    </div>
                  </div>
                  <Slider {...settingsprojectslide} className="project-slider owl-carousel">

                    <div className="project-grid">
                      <div className="project-top">
                        <h6>
                          <Link to="/project-view">Deadline : 10 Feb 2024</Link>
                        </h6>
                        <h5>
                          <Link to="/project-view">Office Management</Link>
                        </h5>
                        <p>
                          Creating an online platform that enables various
                          administrative tasks within an organization
                        </p>
                      </div>
                      <div className="project-middle">
                        <ul className="nav">
                          <li>
                            <div className="project-tasks">
                              <h4>20</h4>
                              <p>Total Tasks</p>
                            </div>
                          </li>
                          <li>
                            <div className="project-tasks">
                              <h4>15</h4>
                              <p>Total Completed</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="project-bottom">
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Project Leader :</li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Jeffery Lalor"
                                data-bs-original-title="Jeffery Lalor"
                              >
                                <img
                                  src={avatar19}
                                  alt="User"
                                />
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Members :</li>
                            <li>

                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar20}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip1}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar19}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip2}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar20}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip3}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar16}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip4}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar23}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="more-team-members"
                              >
                                +16
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                   
                    <div className="project-grid">
                      <div className="project-top">
                        <h6>
                          <Link to="/project-view">Deadline : 15 Feb 2024</Link>
                        </h6>
                        <h5>
                          <Link to="/project-view">Video Calling App</Link>
                        </h5>
                        <p>
                          Design and developing a software application that enables
                          users to make video calls over the internet.
                        </p>
                      </div>
                      <div className="project-middle">
                        <ul className="nav">
                          <li>
                            <div className="project-tasks">
                              <h4>30</h4>
                              <p>Total Tasks</p>
                            </div>
                          </li>
                          <li>
                            <div className="project-tasks">
                              <h4>12</h4>
                              <p>Total Completed</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="project-bottom">
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Project Leader :</li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip5}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar18}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                          </ul>
                        </div>
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Members :</li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip6}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar21}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip7}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar16}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip8}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar20}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>

                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip9}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar1}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip10}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar23}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="more-team-members"
                              >
                                +10
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                 
                    <div className="project-grid">
                      <div className="project-top">
                        <h6>
                          <Link to="/project-view">Deadline : 12 Apr 2024</Link>
                        </h6>
                        <h5>
                          <Link to="/project-view">Hospital Administration</Link>
                        </h5>
                        <p>
                          Creating an online platform that serves as a central hub
                          for hospital admin, staff, patients.
                        </p>
                      </div>
                      <div className="project-middle">
                        <ul className="nav">
                          <li>
                            <div className="project-tasks">
                              <h4>40</h4>
                              <p>Total Tasks</p>
                            </div>
                          </li>
                          <li>
                            <div className="project-tasks">
                              <h4>02</h4>
                              <p>Total Completed</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="project-bottom">
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Project Leader :</li>
                            <li>

                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip11}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar4}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                          </ul>
                        </div>
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Members :</li>
                            <li>

                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip12}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar6}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>

                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip13}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar13}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>

                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip14}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar18}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip15}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar23}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                             
                              <OverlayTrigger
                                placement="top"
                                overlay={tooltip16}
                              >
                                <Link to="/project-view">
                                  <img
                                    src={avatar1}
                                    alt="User"
                                  />
                                </Link>
                              </OverlayTrigger>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="more-team-members"
                              >
                                +12
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                   
                    <div className="project-grid">
                      <div className="project-top">
                        <h6>
                          <Link to="/project-view">Deadline : 25 Apr 2024</Link>
                        </h6>
                        <h5>
                          <Link to="/project-view">Digital Marketpace</Link>
                        </h5>
                        <p>
                          Creating an online platform that connects sellers with
                          buyers, facilitating the exchange of goods,
                        </p>
                      </div>
                      <div className="project-middle">
                        <ul className="nav">
                          <li>
                            <div className="project-tasks">
                              <h4>50</h4>
                              <p>Total Tasks</p>
                            </div>
                          </li>
                          <li>
                            <div className="project-tasks">
                              <h4>10</h4>
                              <p>Total Completed</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="project-bottom">
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Project Leader :</li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Jeffery Lalor"
                                data-bs-original-title="Jeffery Lalor"
                              >
                                <img
                                  src={avatar1}
                                  alt="User"
                                />
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Members :</li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Loren Gatlin"
                                data-bs-original-title="Loren Gatlin"
                              >
                                <img
                                  src={avatar26}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Lesley Grauer"
                                data-bs-original-title="Lesley Grauer"
                              >
                                <img
                                  src={avatar18}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Richard Miles"
                                data-bs-original-title="Richard Miles"
                              >
                                <img
                                  src={avatar6}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Jeffery Lalor"
                                data-bs-original-title="Jeffery Lalor"
                              >
                                <img
                                  src={avatar13}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Tarah Shropshire"
                                data-bs-original-title="Tarah Shropshire"
                              >
                                <img
                                  src={avatar8}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="more-team-members"
                              >
                                +13
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
               
                    <div className="project-grid">
                      <div className="project-top">
                        <h6>
                          <Link to="/project-view">Deadline : 15 Feb 2024</Link>
                        </h6>
                        <h5>
                          <Link to="/project-view">Video Calling App</Link>
                        </h5>
                        <p>
                          Design and developing a software application that enables
                          users to make video calls over the internet.
                        </p>
                      </div>
                      <div className="project-middle">
                        <ul className="nav">
                          <li>
                            <div className="project-tasks">
                              <h4>30</h4>
                              <p>Total Tasks</p>
                            </div>
                          </li>
                          <li>
                            <div className="project-tasks">
                              <h4>12</h4>
                              <p>Total Completed</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="project-bottom">
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Project Leader :</li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Catherine Manseau"
                                data-bs-original-title="Catherine Manseau"
                              >
                                <img
                                  src={avatar18}
                                  alt="User"
                                />
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="project-leader">
                          <ul className="nav">
                            <li>Members :</li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Richard Miles"
                                data-bs-original-title="Richard Miles"
                              >
                                <img
                                  src={avatar21}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Jeffery Lalor"
                                data-bs-original-title="Jeffery Lalor"
                              >
                                <img
                                  src={avatar16}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Lesley Grauer"
                                data-bs-original-title="Lesley Grauer"
                              >
                                <img
                                  src={avatar20}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Loren Gatlin"
                                data-bs-original-title="Loren Gatlin"
                              >
                                <img
                                  src={avatar1}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/project-view"
                                data-bs-toggle="tooltip"
                                aria-label="Tarah Shropshire"
                                data-bs-original-title="Tarah Shropshire"
                              >
                                <img
                                  src={avatar23}
                                  alt="User"
                                />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="more-team-members"
                              >
                                +10
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row">
          <div className="col-xl-6 col-md-12 d-flex">
              <SliderComponent
                title="Birthdays"
                loading={birthdayLoading}
                list={birthdays}
                type="birthday"
                count={birthdays.length}
              />
            </div>
            <div className="col-xl-6 col-md-12 d-flex">
              <SliderComponent
                title="Work Anniversary"
                loading={anniversaryLoading}
                list={anniversary}
                type="anniversary"
                count={anniversary.length}
              />
              {}
            </div>

           
          </div>

          <div className="row">
        
          {
              user?.role?.access_scope !== "self" && 
              <div className="col-xl-6 col-md-12 d-flex">
              <SliderComponent
                title="New Joiners"
                loading={newJoinersLoading}
                list={newJoiners}
                type="new_joiners"
                count={newJoiners.length}
              />
            </div>
            }
           
            {/* /Company Policy */}
            {
              user?.role?.access_scope !== "self" && 
              <div className="col-xl-6 col-md-12 d-flex">
              <SliderComponent
                title="Resigned/Left"
                loading={terminatedLoading}
                list={terminated}
                type="terminated"
                count={terminated.length}
              />
            </div>
            }

           
          </div>

          {/* Document Expiry Cards Row */}
          <div className="row">
            <div className="col-xl-6 col-md-12 d-flex">
              <DocumentExpiryCard
                title="User Document Expiry"
                data={userDocumentExpiry}
                filter={userExpiryFilter}
                setFilter={setUserExpiryFilter}
                loading={documentExpiryLoading}
                type="user"
                icon="👤📄"
              />
            </div>
            <div className="col-xl-6 col-md-12 d-flex">
              <DocumentExpiryCard
                title="Store Document Expiry"
                data={storeDocumentExpiry}
                filter={storeExpiryFilter}
                setFilter={setStoreExpiryFilter}
                loading={documentExpiryLoading}
                type="store"
                icon="🏪📄"
              />
            </div>
          </div>
          {/* End Document Expiry Cards Row */}
        </div>
        {/* /Page Content */}
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default EmployeeDashboard;
